import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLFormElement> {
  static targets = ['mark', 'form']

  declare readonly markTargets: [HTMLElement]
  declare readonly formTargets: [HTMLFormElement]

  confirmedToProceed = false
  boundBeforeUnload = this.beforeUnload.bind(this)
  boundConfirm = this.confirm.bind(this)

  connect (): void {
    window.addEventListener('beforeunload', this.boundBeforeUnload)
    document.addEventListener('turbo:before-visit', this.boundConfirm)
  }

  disconnect (): void {
    window.removeEventListener('beforeunload', this.boundBeforeUnload)
    document.removeEventListener('turbo:before-visit', this.boundConfirm)
  }

  changed ({ target }: { target: HTMLInputElement }): void {
    const f = target.closest('form')

    if ((f == null) || !this.formTargets.includes(f)) return

    const i = this.formTargets.indexOf(f)

    if (i === -1 || this.markTargets[i] === null) return

    this.markTargets[i].classList.remove('hidden')
    this.confirmedToProceed = false
  }

  saved ({ target }: { target: HTMLFormElement }): void {
    if (!this.formTargets.includes(target)) return

    const i = this.formTargets.indexOf(target)

    if (i === -1 || this.markTargets[i] === null) return

    this.markTargets[i].classList.add('hidden')
  }

  confirm (event: Event): void {
    if (this.confirmedToProceed || !this.anyUnsaved()) return

    if (window.confirm(this.message())) {
      if (event.type !== 'turbo:before-visit') this.confirmedToProceed = true
      return
    }

    event.preventDefault()
    event.stopImmediatePropagation()
  }

  private beforeUnload (event: Event): void {
    if (this.confirmedToProceed || !this.anyUnsaved()) return

    event.preventDefault()
  }

  private anyUnsaved (): boolean {
    return this.markTargets.some(mark => !mark.classList.contains('hidden'))
  }

  private message (): string {
    return this.element.dataset.message ?? 'You have unsaved changes. Are you sure you want to proceed?'
  }
}
